<div class="app-expo-list">
    <!-- <div class="input-div">
        <input type="text" class="search" placeholder="Search Vendors">
        <i class="fa fa-search search-icon" aria-hidden="true" ></i>
    </div> -->
    <div class="mb-15 text-center" *ngIf="expoList?.length == 0 && dataExists">
        No records found
    </div>
    <div class="row mb-15 align-items-center" *ngIf="expoList?.length > 0">
        <h1 class="col-4 col-md-6 mb-0 fs-18 expo-header">Expo</h1>
        <div class="text-right col-8 col-md-6">
            <button class="filter-box" *ngIf="selectedExpo == 'All'" (click)="toggleFilter('vendors')" mat-button>
                All
                <i class="fa fa-angle-down pr-5 pull-right"
                    aria-hidden="true"></i>
            </button>
            <button class="filter-box" matTooltipPosition="above"
            matTooltip="{{selectedExpo}}" *ngIf="selectedExpo != 'All' && selectedExpo.length > 20" (click)="toggleFilter('vendors')" mat-button>
                {{selectedExpo | slice: 0:20}}
                {{selectedExpo.length > 20 ? "..." : ""}}
                <i class="fa fa-angle-down pr-5 pull-right"
                    aria-hidden="true"></i>
            </button>
            <button class="filter-box" *ngIf="selectedExpo != 'All' && selectedExpo.length <= 20" (click)="toggleFilter('vendors')" mat-button>
                {{selectedExpo}}
                <i class="fa fa-angle-down pr-5 pull-right"
                    aria-hidden="true"></i>
            </button>
            <ng-container *ngIf="showVendor">
                <div class="filter-block">
                    <div class="cat-block">
                        <h6 (click)="getSelectedExpo(expo,'all')" *ngIf="selectedExpo != all" class="pointer">
                            All</h6>
                    </div>
                    <div class="cat-block" *ngFor="let expo of expoResp">
                        <h6 (click)="getSelectedExpo(expo)" *ngIf="selectedExpo != expo.type && expo?.type.length > 20 && expo.type"
                            matTooltipPosition="above"
                                        matTooltip="{{expo.type}}" class="pointer">
                            {{expo?.type | slice: 0:20}}
                            {{expo?.type.length > 20 ? "..." : ""}}
                        </h6>
                        <h6 (click)="getSelectedExpo(expo)" *ngIf="selectedExpo != expo.type && expo?.type.length <= 20 && expo.type"
                             class="pointer">
                            {{expo?.type}}
                        </h6>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="row align-items-center justify-content-center" *ngIf="streamAds && eventHomeAdsTop && eventHomeAdsTop.length > 0 ">
        <div class="col-12 col-md-7">
            <div id="myCarousel" class="carousel text-center slide mb-20" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsTop && eventHomeAdsTop.length > 0 ">
                        <div *ngFor="let a of eventHomeAdsTop; let i=index" class="adv-img1 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
       
    </div>
    <!-- Top Adds End -->
    <div class="list mt-50">
        <ng-container *ngIf="expoList?.length > 0">
            <div class="row">
                <div [ngClass] = "streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0 ? 'col-12 col-md-8 col-lg-10' : 'col-12'">

                
            <div *ngFor="let expoType of expoList">
                <div class="row p-1 pl-0 mt-0  expo-type heading-div align-items-center no-gutters" *ngIf="expoType?.type">
                    <div class="col-6 col-md-6 d-flex text-right">
                        <i *ngIf="selectedExpo ==expoType?.type" (click)="getSelectedExpo(expo,'all')"
                            class="fa fa-chevron-left pointer p-t-1" aria-hidden="true"></i><span
                            class="list-heading pl-2 text-right">{{expoType.type}}</span>
                    </div>
                    <div class="col-6 col-md-6 text-right"
                    *ngIf="expoType?.expoData?.length > 2 && selectedExpo != expoType?.type">
                        <span class="see-all pointer pr-1" (click)="getSelectedExpo(expoType)"> See
                            All({{expoType.expoData.length}})</span>
                    </div>
                </div>
               
                    <div class="row  pointer"> 
                         <div class="col-12 col-md-6 pointer" *ngFor="let expo of expoType.expoData| slice: 0:selectedVal" (click)="goDetails(expo.id)">
                        <div class="image-div" [ngStyle]="{'background-image':' url(' + expo?.banner + ')'}">
                            <div class="myOverlay"></div>
                            <div>
                                <div class="sponsor-logo" [ngStyle]="{'background-image':' url(' + expo?.logo + ')'}">
                                </div>
                                <span class="text-left text-pos name-break">
                                    <p class="fs-20" *ngIf="expo?.name && expo?.name.length <= 30"> {{expo?.name}}</p>
                                    <p *ngIf="expo?.name && expo?.name.length > 30" matTooltipPosition="above"
                                        matTooltip="{{expo.name}}" class="pointer">
                                        {{expo?.name | slice: 0:30}}
                                        {{expo?.name.length > 30 ? "..." : ""}}
                                    </p>
                                    <p *ngIf="expo?.about && expo?.about.length <= 80" class="pointer">{{expo?.about}}
                                    </p>
                                    <p *ngIf="s?.about && s?.about.length > 80" matTooltipPosition="above"
                                        matTooltip="{{expo.about}}" class="pointer">
                                        {{expo?.about | slice: 0:80}}
                                        {{expo?.about.length > 80 ? "..." : ""}}
                                    </p>
                                </span>
                            </div>
                        </div>
                    </div></div>
            </div>
        </div>
            <div class="col-12 col-md-4 col-lg-2" *ngIf="streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0">
                <!-- Right Ads Start -->
                <div><div class="pointer">    <div id="RightCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
                    <div class="carousel-inner">
                        <ng-container>
                            <div *ngFor="let a of eventHomeAdsRight; let i=index" class="adv-img2 carousel-item"
                                id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                            </div>
                            <div class="ad-position">
                                <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i class="fa fa-external-link fs-9 ml-1" ></i></a></span> 
                            </div>
                        </ng-container>
                    </div>
                </div></div></div>
            </div>
        </div>
        </ng-container>
        <!-- <ng-container *ngIf="startupArr?.length>0 && (selectedVendor =='Startups' || selectedVendor =='All')">
            <div class="row heading-div align-items-center">
                <div class="col-6 col-md-6">
                    <i *ngIf="selectedVendor =='Startups'" (click)="getExpoList()"
                        class="fa fa-chevron-left pointer pr-15" aria-hidden="true"></i><span
                        class="list-heading">Startups</span>
                </div>
                <div class="col-6 col-md-6 text-right" *ngIf="startupList?.length>2 && selectedVendor !='Startups'">
                    <span class="see-all pointer" (click)="getSelectedVendor('Startups','Startups')"> See
                        All({{startupList?.length}})</span>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 pointer" *ngFor="let s of startupArr" (click)="goDetails(s.id)">
                    <div class="image-div" [ngStyle]="{'background-image':' url(' + s?.banner + ')'}">
                        <div class="myOverlay"></div>
                        <div>
                            <div class="sponsor-logo" [ngStyle]="{'background-image':' url(' + s?.logo + ')'}"></div>
                            <span class="text-left text-pos">
                                <p class="fs-20" *ngIf="s?.name && s?.name.length <= 50"> {{s?.name}}</p>
                                <p *ngIf="s?.name && s?.name.length > 50" matTooltipPosition="above"
                                    matTooltip="{{s.name}}" class="pointer">
                                    {{s?.name | slice: 0:50}}
                                    {{s?.name.length > 50 ? "..." : ""}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length <= 150" class="pointer">{{s?.about}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length > 150" matTooltipPosition="above"
                                    matTooltip="{{s.about}}" class="pointer">
                                    {{s?.about | slice: 0:150}}
                                    {{s?.about.length > 150 ? "..." : ""}}
                                </p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="scholarArr?.length>0 && (selectedVendor =='Research Scholar' || selectedVendor =='All')">
            <div class="row heading-div align-items-center">
                <div class="col-6 col-md-6">
                    <i *ngIf="selectedVendor =='Research Scholar'" (click)="getExpoList()"
                        class="fa fa-chevron-left pointer pr-15" aria-hidden="true"></i><span
                        class="list-heading">Research Scholars</span>
                </div>
                <div class="col-6 col-md-6 text-right"
                    *ngIf="scholarList?.length>2 && selectedVendor !='Research Scholar'">
                    <span class="see-all pointer" (click)="getSelectedVendor('Research Scholar','Research Scholar')">
                        See All({{scholarList?.length}})</span>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 pointer" *ngFor="let s of scholarArr" (click)="goDetails(s.id)">
                    <div class="image-div" [ngStyle]="{'background-image':' url(' + s?.banner + ')'}">
                        <div class="myOverlay"></div>
                        <div>
                            <div class="sponsor-logo" [ngStyle]="{'background-image':' url(' + s?.logo + ')'}"></div>
                            <span class="text-left text-pos">
                                <p class="fs-20" *ngIf="s?.name && s?.name.length <= 50"> {{s?.name}}</p>
                                <p *ngIf="s?.name && s?.name.length > 50" matTooltipPosition="above"
                                    matTooltip="{{s.name}}">
                                    {{s?.name | slice: 0:50}}
                                    {{s?.name.length > 50 ? "..." : ""}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length <= 150">{{s?.about}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length > 150" matTooltipPosition="above"
                                    matTooltip="{{s.about}}">
                                    {{s?.about | slice: 0:150}}
                                    {{s?.about.length > 150 ? "..." : ""}}
                                </p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="pitchArr?.length>0 && (selectedVendor =='Pitches' || selectedVendor =='All')">
            <div class="row heading-div align-items-center">
                <div class="col-6 col-md-6">
                    <i *ngIf="selectedVendor =='Pitches'" (click)="getExpoList()"
                        class="fa fa-chevron-left pointer pr-15" aria-hidden="true"></i><span
                        class="list-heading">Pitches</span>
                </div>
                <div class="col-6 col-md-6 text-right" *ngIf="pitchesList?.length>2 && selectedVendor !='Pitches'">
                    <span class="see-all pointer" (click)="getSelectedVendor('Pitches','Pitches')"> See
                        All({{pitchesList?.length}})</span>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 pointer" *ngFor="let s of pitchArr" (click)="goDetails(s.id)">
                    <div class="image-div" [ngStyle]="{'background-image':' url(' + s?.banner + ')'}">
                        <div class="myOverlay"></div>
                        <div>
                            <div class="sponsor-logo" [ngStyle]="{'background-image':' url(' + s?.logo + ')'}"></div>
                            <span class="text-left text-pos">
                                <p class="fs-20" *ngIf="s?.name && s?.name.length <= 50"> {{s?.name}}</p>
                                <p *ngIf="s?.name && s?.name.length > 50" matTooltipPosition="above"
                                    matTooltip="{{s.name}}" class="pointer">
                                    {{s?.name | slice: 0:50}}
                                    {{s?.name.length > 50 ? "..." : ""}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length <= 150" class="pointer">{{s?.about}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length > 150" matTooltipPosition="above"
                                    matTooltip="{{s.about}}" class="pointer">
                                    {{s?.about | slice: 0:150}}
                                    {{s?.about.length > 150 ? "..." : ""}}
                                </p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="techArr?.length>0 && (selectedVendor =='Film and Technology' || selectedVendor =='All')">
            <div class="row heading-div align-items-center">
                <div class="col-6 col-md-6">
                    <i *ngIf="selectedVendor =='Film and Technology'" (click)="getExpoList()"
                        class="fa fa-chevron-left pointer pr-15" aria-hidden="true"></i><span class="list-heading">Film
                        and Technology</span>
                </div>
                <div class="col-6 col-md-6 text-right"
                    *ngIf="technologyList?.length>2 && selectedVendor !='Film and Technology'">
                    <span class="see-all pointer"
                        (click)="getSelectedVendor('Film and Technology','Film and Technology')"> See
                        All({{technologyList?.length}})</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 pointer" *ngFor="let s of techArr" (click)="goDetails(s.id)">
                    <div class="image-div" [ngStyle]="{'background-image':' url(' + s?.banner + ')'}">
                        <div class="myOverlay"></div>
                        <div>
                            <div class="sponsor-logo" [ngStyle]="{'background-image':' url(' + s?.logo + ')'}"></div>
                            <span class="text-left text-pos">
                                <p class="fs-20" *ngIf="s?.name && s?.name.length <= 50"> {{s?.name}}</p>
                                <p *ngIf="s?.name && s?.name.length > 50" matTooltipPosition="above"
                                    matTooltip="{{s.name}}" class="pointer">
                                    {{s?.name | slice: 0:50}}
                                    {{s?.name.length > 50 ? "..." : ""}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length <= 150" class="pointer">{{s?.about}}
                                </p>
                                <p *ngIf="s?.about && s?.about.length > 150" matTooltipPosition="above"
                                    matTooltip="{{s.about}}" class="pointer">
                                    {{s?.about | slice: 0:150}}
                                    {{s?.about.length > 150 ? "..." : ""}}
                                </p>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container> -->
    </div>
</div>